import { useQuery } from "react-query"
import { getApiKeys } from "api/apiKeys"

export const apiKeysCacheKey = (eventId: string) => ["apiKeys", eventId]

export const useApiKeys = (eventId: string) => useQuery(
  apiKeysCacheKey(eventId),
  () => getApiKeys(eventId).then(({ data }) => data.data),
  { enabled: Boolean(eventId) },
)
